import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './annuals.types';
import * as constants from './annuals.constants';

export const annualsReducer = generateResourceReducer<types.IAnnual>({
  STORE: constants.STORE_ANNUAL,
  CLEAR: constants.CLEAR_ANNUAL,
});
